import React, { useState, useEffect, useCallback } from "react";
import { Card, CardBody, CardTitle, Button, Row, Col } from "reactstrap";
import { FormattedMessage } from "react-intl";
import {
  GetLicenseManagementCustomers,
  GetLicenseManagementCourses,
} from "../../actions/superUserQueries";
import "@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css";
import "open-iconic/font/css/open-iconic-bootstrap.css";
import {
  SortingState,
  IntegratedSorting,
  SearchState,
} from "@devexpress/dx-react-grid";
import {
  Grid,
  TableHeaderRow,
  Table,
  SearchPanel,
  Toolbar,
  TableColumnResizing,
} from "@devexpress/dx-react-grid-bootstrap4";
import { useQuery } from "react-query";
import LicMgtCustomerModal from "../../components/Modal/LicMgtCustomerModal";
import LicMgtHandleCoursesModal from "../../components/Modal/LicMgtHandleCoursesModal";
import LicMgtCreateCustomerModal from "../../components/Modal/LicMgtCreateCustomerModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { WarnLimitForLicMgt } from "../../constants/ConstantVars";
import { injectIntl } from "react-intl";

function LicMgtAdministration({ intl }) {
  const [searchValue, setSearchValue] = useState("");
  const [customerRows, setCustomerRows] = useState([]);
  const [openCustomer, setOpenCustomer] = useState(null);
  const [createNewCustomerOpen, setCreateNewCustomerOpen] = useState(false);
  const [toggleUpdate, setToggleUpdate] = useState(false);
  const [coursesModalOpen, setCoursesModalOpen] = useState(false);
  const licenseCourses = useQuery(
    "FetchLicenseManagementCourses",
    GetLicenseManagementCourses()
  );

  const licenseCustomers = useQuery(
    "FetchLicenseManagementCustomers",
    GetLicenseManagementCustomers()
  );

  const licenseManagementTableColumns = [
    { name: "name", title: <FormattedMessage id="Name" /> },
    { name: "url", title: <FormattedMessage id="Url" /> },
    { name: "fortNoxNumber", title: <FormattedMessage id="FortnoxNumber" /> },
    { name: "address", title: <FormattedMessage id="Address" /> },
    {
      name: "nbrOfLicenses",
      title: <FormattedMessage id="NumberOfLicenses" />,
    },
    {
      name: "nbrOfValidLicenses",
      title: <FormattedMessage id="NumberOfValidLicenses" />,
    },
    {
      name: "nbrOfLicensesNotUsed",
      title: <FormattedMessage id="NumberOfUnusedLicenses" />,
    },
    { name: "created", title: <FormattedMessage id="Created" /> },
    { name: "status", title: <FormattedMessage id="Status" /> },
  ];

  let sizingExtensions = [
    { columnName: "name", width: 150 },
    { columnName: "url", width: 170 },
    { columnName: "fortNoxNumber", width: 170 },
    { columnName: "address", width: 210 },
    { columnName: "nbrOfLicenses", width: 140 },
    { columnName: "nbrOfValidLicenses", width: 190 },
    { columnName: "nbrOfLicensesNotUsed", width: 190 },
    { columnName: "created", width: 100 },
    { columnName: "status", width: 90 },
  ];

  const compareNamePriority = (a, b) => {
    const priorityA = a;
    const priorityB = b;
    if (priorityA === priorityB) {
      return 0;
    }
    return priorityA < priorityB ? -1 : 1;
  };
  const compareFormattedPriority = (a, b) => {
    const priorityA = a.props.sortorder;
    const priorityB = b.props.sortorder;
    if (priorityA === priorityB) {
      return 0;
    }
    return priorityA < priorityB ? -1 : 1;
  };

  const integratedSortingColumnExtensions = [
    { columnName: "name", compare: compareNamePriority },
    { columnName: "url", compare: compareNamePriority },
    { columnName: "fortNoxNumber", compare: compareNamePriority },
    { columnName: "address", compare: compareNamePriority },
    { columnName: "nbrOfLicenses", compare: compareNamePriority },
    { columnName: "nbrOfValidLicenses", compare: compareNamePriority },
    { columnName: "nbrOfLicensesNotUsed", compare: compareNamePriority },
    { columnName: "created", compare: compareNamePriority },
    { columnName: "status", compare: compareFormattedPriority },
  ];

  const getStatusIcon = useCallback(
    (company) => {
      const statuses = {
        noLicensesLeft: "noLicensesLeft",
        belowThresholdForWarnLeft: "belowThresholdForWarnLeft",
        ok: "ok",
        attentionNeeded: "attentionNeeded",
      };
      let currentStatus = statuses.ok;
      let coursesWithWarnings = [];

      company.licensesPerCourse.forEach((course) => {
        if (course.nbrOfLicensesNotUsed === 0) {
          currentStatus = statuses.noLicensesLeft;
          coursesWithWarnings.push(course.course.name);
        } else if (course.nbrOfLicensesNotUsed < WarnLimitForLicMgt + 1) {
          if (currentStatus !== statuses.noLicensesLeft) {
            currentStatus = statuses.belowThresholdForWarnLeft;
          }
          coursesWithWarnings.push(course.course.name);
        }
      });

      if (
        company.licenses.length ===
          company.licenses.filter((li) => li.firstRun === null).length &&
        company.licenses.length > 0
      ) {
        if (
          moment(
            company.licenses.sort(function (a, b) {
              return b.created.localeCompare(a.created);
            })[0].created
          ).diff(moment(), "months") < 0
        ) {
          if (currentStatus === statuses.ok) {
            currentStatus = statuses.attentionNeeded;
          }
        }
      }

      if (
        company.nbrOfLicenses === 0 &&
        company.nbrOfLicensesNotUsed === 0 &&
        moment(company.customer.created).diff(moment(), "months") < 0
      ) {
        if (currentStatus === statuses.ok) {
          currentStatus = statuses.attentionNeeded;
        }
      }

      switch (currentStatus) {
        case statuses.noLicensesLeft:
          return (
            <FontAwesomeIcon
              sortorder={1}
              icon="exclamation-triangle"
              className={"text-danger"}
            />
          );
        case statuses.belowThresholdForWarnLeft:
          return (
            <FontAwesomeIcon
              sortorder={2}
              title={coursesWithWarnings.toString()}
              icon="exclamation-triangle"
              className="text-warning"
            />
          );
        case statuses.attentionNeeded:
          return (
            <FontAwesomeIcon
              sortorder={3}
              icon="thumbs-up"
              className="text-warning"
              title={intl.formatMessage({
                id: "LicensesUnchangedForOverAMonth",
              })}
            />
          );
        case statuses.ok:
          return (
            <FontAwesomeIcon
              icon="thumbs-up"
              className="text-success"
              sortorder={4}
            />
          );
        default:
          return (
            <FontAwesomeIcon
              icon="thumbs-up"
              className="text-success"
              sortorder={4}
            />
          );
      }
    },
    [intl]
  );

  useEffect(() => {
    if (!licenseCustomers.isLoading) {
      const licenseManagementTableDataSource = [];
      licenseCustomers.data
        .filter(
          (item) =>
            item.customer.name
              .toLowerCase()
              .includes(searchValue.toLowerCase()) ||
            item.customer.url
              .toLowerCase()
              .includes(searchValue.toLowerCase()) ||
            item.customer.fortNoxNumber
              .toLowerCase()
              .includes(searchValue.toLowerCase()) ||
            item.customer.address
              .toLowerCase()
              .includes(searchValue.toLowerCase()) ||
            item.customer.city.toLowerCase().includes(searchValue.toLowerCase())
        )
        .forEach((companyItem) => {
          let company = {
            uniqueId: companyItem.customer.id,
            name: companyItem.customer.name,
            url: companyItem.customer.url,
            fortNoxNumber: companyItem.customer.fortNoxNumber,
            address:
              companyItem.customer.address +
              " " +
              companyItem.customer.city +
              " " +
              companyItem.customer.zipCode,
            nbrOfLicenses: companyItem.nbrOfLicenses,
            nbrOfValidLicenses: companyItem.nbrOfValidLicenses,
            nbrOfLicensesNotUsed: companyItem.nbrOfLicensesNotUsed,
            created: moment(companyItem.customer.created).format("L"),
            status: getStatusIcon(companyItem),
          };
          licenseManagementTableDataSource.push(company);
        });
      setCustomerRows(licenseManagementTableDataSource);
    }
  }, [
    licenseCustomers.isLoading,
    licenseCustomers.data,
    searchValue,
    toggleUpdate,
    getStatusIcon,
  ]);

  if (licenseCustomers.isLoading) {
    return <></>;
  }

  const TableRow = ({ row, ...restProps }) => (
    <Table.Row
      {...restProps}
      // eslint-disable-next-line no-alert
      onClick={() =>
        setOpenCustomer(
          licenseCustomers.data.find(
            (item) => item.customer.id === row.uniqueId
          )
        )
      }
      className="license-management-table--row"
      style={{
        cursor: "pointer",
      }}
    />
  );

  const TableComponent = ({ ...restProps }) => (
    <Table.Table {...restProps} className="table-striped" />
  );

  const getRowId = (row) => row.uniqueId;

  return (
    <Card>
      <CardBody>
        <CardTitle>
          <FormattedMessage id="Navigation_Administration_Licenses" />
        </CardTitle>

        <div className="card">
          <Row>
            <Col>
              <Button
                className="m-2"
                outline
                color="primary"
                onClick={() => setCreateNewCustomerOpen(true)}
              >
                <FontAwesomeIcon icon="plus" className="me-2" />
                <FormattedMessage id="AddCustomer" />
              </Button>
              <Button
                className="m-2"
                outline
                color="primary"
                onClick={() => setCoursesModalOpen(true)}
              >
                Hantera kurser
              </Button>
            </Col>
          </Row>
          <Grid
            rows={customerRows}
            columns={licenseManagementTableColumns}
            getRowId={getRowId}
          >
            <SearchState value={searchValue} onValueChange={setSearchValue} />
            <SortingState />
            <IntegratedSorting
              columnExtensions={integratedSortingColumnExtensions}
            />
            <Table
              striped={true}
              tableComponent={TableComponent}
              rowComponent={TableRow}
            />
            <TableColumnResizing defaultColumnWidths={sizingExtensions} />
            <TableHeaderRow showSortingControls />
            <Toolbar />
            <SearchPanel />
          </Grid>
        </div>
      </CardBody>
      <LicMgtCustomerModal
        toggle={() => setOpenCustomer(null)}
        isOpen={openCustomer !== null}
        customer={openCustomer}
        licenseCourses={licenseCourses}
        handleUpdateData={() => setToggleUpdate(!toggleUpdate)}
        toggleUpdate={toggleUpdate}
      />
      <LicMgtCreateCustomerModal
        toggle={() => setCreateNewCustomerOpen(false)}
        isOpen={createNewCustomerOpen}
        licenseCustomers={licenseCustomers}
      />
      <LicMgtHandleCoursesModal
        toggle={() => setCoursesModalOpen(!coursesModalOpen)}
        isOpen={coursesModalOpen}
      />
    </Card>
  );
}

export default injectIntl(LicMgtAdministration);
